// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../dealer-transfer-history/state/report';
import actions from '../../actions-list';

const updateDealerTransferHistoryReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_DEALER_TRANSFER_HISTORY_REPORT_SUCCESS]: updateDealerTransferHistoryReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateDealerTransferHistoryReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/reducers/report.js